exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#remoteSmartLinkIOT {\n  text-align: center;\n  margin: 0 auto;\n}\n#remoteSmartLinkIOT img {\n  display: block;\n  margin: 0 auto;\n  width: 100%;\n  max-width: 760px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/staticPage/remoteSmartLinkIOT/index.less
// module id = 463
// module chunks = 0